class AkamaiError extends Error {
  id: string;
  constructor(id: string) {
    super('Akamai Error');
    this.id = id;
  }
}

export { AkamaiError };
